<div class="thread" *ngFor="let comment of showComments; last as isLast">
  <div class="image">
    <div class="img-container" [ngClass]="{ default: !comment.imgUrl }">
      <img *ngIf="comment.imgUrl" [src]="comment.imgUrl" />
      <img *ngIf="!comment.imgUrl" [src]="defaultImgUrl" />
    </div>

    <div
      class="line"
      [ngClass]="{ hide: (seeMoreOldest || !oldestComments.length) && isLast }"
    ></div>
  </div>

  <div class="content">
    <div class="user-info">
      <p class="name">{{ comment.userName }}</p>
      <span>·</span>
      <p>{{ comment.date | countryDate : "dateWithHourMinutes" }}</p>
    </div>

    <div class="message" #message [ngClass]="{ expand: comment.expand }">
      {{ comment.message }}
    </div>

    <div
      *ngIf="!comment.expand && comment.showSeeMore"
      class="see-more"
      (click)="handleClickSeeMoreComment(comment)"
    >
      {{ "show-more" | translate }}
    </div>
  </div>
</div>

<div
  class="see-more-comments"
  (click)="handleClickSeeMoreOldest()"
  *ngIf="oldestComments.length && !seeMoreOldest"
>
  <div class="line-see-more">
    <div></div>
    <div></div>
    <div></div>
  </div>

  <p>{{ "show-previous-comments" | translate }}</p>
</div>
